import React from "react";
import { useLang } from "../i18n";

const formatPrice = (p, lang) =>
  new Intl.NumberFormat(lang === "fr" ? "fr-CA" : "en-CA", {
    style: "currency", currency: "CAD", maximumFractionDigits: 0,
  }).format(p);

export default function PropertyCard({ property, onClick }) {
  const { lang, t } = useLang();
  const title = lang === "fr" ? property.title_fr : property.title_en;
  const isSold = property.status === "sold";

  return (
    <article
      onClick={onClick}
      className="group cursor-pointer bg-[#141414] border border-white/5 hover:border-[#D4AF37]/40 transition-all duration-500"
      data-testid={`property-card-${property.id}`}
    >
      <div className="zoom-wrap relative aspect-[1/1] overflow-hidden">
        <img
          src={property.images?.[0] || "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80"}
          alt={title}
          loading="lazy"
          className="zoom-img w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        {isSold && (
          <span className="absolute top-4 left-4 bg-[#D4AF37] text-black text-[0.65rem] uppercase tracking-[0.25em] px-3 py-1 font-medium">
            {t.sold.sold_tag}
          </span>
        )}
      </div>
      <div className="p-6 md:p-8">
        <div className="text-[0.65rem] uppercase tracking-[0.25em] text-[#D4AF37] mb-3">
          {property.neighborhood}
        </div>
        <h3 className="font-serif text-2xl md:text-3xl text-[#F5F5F0] mb-3 leading-tight">
          {title}
        </h3>
        <div className="flex items-center gap-4 text-xs text-white/50 mb-5 min-h-[1rem]">
          {property.bedrooms > 0 && <><span>{property.bedrooms} ch</span><span className="w-1 h-1 bg-white/20 rounded-full" /></>}
          {property.bathrooms > 0 && <><span>{property.bathrooms} sdb</span><span className="w-1 h-1 bg-white/20 rounded-full" /></>}
          {property.living_area_sqft > 0 && <span>{property.living_area_sqft.toLocaleString(lang === "fr" ? "fr-CA" : "en-CA")} pi²</span>}
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-white/5">
          {property.price > 0 ? (
            <span className="font-serif text-xl text-[#D4AF37]">{formatPrice(property.price, lang)}</span>
          ) : (
            <span />
          )}
          <span className="text-[0.65rem] uppercase tracking-[0.2em] text-white/50 group-hover:text-[#D4AF37] transition-colors">
            {t.featured.view} →
          </span>
        </div>
      </div>
    </article>
  );
}
